// const redirect_uri = "/callback";
// const post_logout_redirect_uri = "/logoutSuccess";
const settings = JSON.parse(process.env.VUE_APP_OIDC_CONFIG);
// settings.redirect_uri = window.origin + redirect_uri
// settings.post_logout_redirect_uri = window.origin + post_logout_redirect_uri;
settings.extraQueryParams = {}
settings.extraQueryParams.host = window.origin.split(".")[0]
settings.automaticSilentRenew = true;
export const oidcSettings = settings;
